export const FEATURE_FLAGS = {
  V2_ENDPOINTS_FMBS_580: 'fmbs-580',
};
